import React from 'react';
import { FormattedMessage, FormattedCurrency } from 'i18n';
import styled from 'styled-components';
import ReactPlaceholder from 'react-placeholder';

import Placeholder from './Placeholder';

export default function PackagePriceComponent({ ready, totalPrice, pricePerPerson }) {
  return (
    <ReactPlaceholder ready={ready} showLoadingAnimation customPlaceholder={<Placeholder />}>
      <Root>
        <PricePerPersonLabel>
          <FormattedMessage id={'perPerson.label'} description={'per person'} defaultMessage={'per person'} />
        </PricePerPersonLabel>
        <PricePerPerson>
          <FormattedCurrency value={pricePerPerson} />
        </PricePerPerson>
        <TotalPriceWrap>
          <TotalPrice>
            <FormattedCurrency value={totalPrice} />
          </TotalPrice>
          &nbsp;&nbsp;
          <TotalPriceLabel>
            <FormattedMessage id={'totalPrice.label'} description={'Total price'} defaultMessage={'Total price'} />
          </TotalPriceLabel>
        </TotalPriceWrap>
      </Root>
    </ReactPlaceholder>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PricePerPersonLabel = styled.div`
  font-size: 1.2em;
  font-weight: 500;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.light};
`;

const PricePerPerson = styled.div`
  font-size: 3.6em;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.price};
`;

const TotalPriceWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
`;

const TotalPrice = styled.div`
  font-size: 1.8em;
  font-weight: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 500 : 700)};
  color: ${({ theme }) => theme.colors.text.default};
`;

const TotalPriceLabel = styled.div`
  font-size: 1.6em;
  font-weight: 500;
  text-transform: lowercase;
  color: ${({ theme }) => theme.colors.text.default};
`;
